import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import {withStyles} from '@material-ui/core';
import {getMutationName, mergeWithDefault} from '../Form/utils';
import swal from 'sweetalert';
import {object, string} from 'yup';
import FormFields from './FormFields';
import Divider from '@material-ui/core/Divider';
import SaveEvent from '../SaveShortcut/FunctionComponent';
import personnelMutations from "../../mutations/personnelMutations";
import {blue, green} from "@material-ui/core/colors";
import moment from "moment";
import {isValidIBAN, isValidBIC, electronicFormatIBAN} from "ibantools";

const manipulateValuesBeforeSave = async (values) => {

    values.working_time_summer = values.working_time_summer && JSON.stringify(values.working_time_summer);
    values.working_time_winter = values.working_time_winter && JSON.stringify(values.working_time_winter);

    ['birth_date','entry_date','exit_date'].forEach((item) => {

        if ( !values[item] || values[item] === '' ) {
            values[item] = null;
        } else {
            values[item] = moment(values[item]).format('YYYY-MM-DD HH:mm:ss');
        }
    });

    ['remuneration_amount','allowance','meal_allowance_1','meal_allowance_2','total_reimbursement','amount_per_km','distance'].forEach(item => {
        if ( values[item] === '' ) {
            values[item] = null;
        }
    })

    return values;
}

const savePersonnel = async (values) => {
    const mutation = values.id > 0 ? personnelMutations.updatePersonnel : personnelMutations.createPersonnel;
    const queryName = getMutationName(mutation);

    let data = await manipulateValuesBeforeSave(values);

    const {data: result} = await window.apolloClient.mutate(
        { mutation, variables: {...data}, errorPolicy: "all"  }
    ).catch((e) => { console.log('graphQLErrors', e ) });

    return result[queryName];
};


const yupLabel = (name) => {
    return i18n.get('personnel.form.' + name);
};

const PersonnelForm = (props) => {
    const {
        handleSubmit,
        classes,
    } = props;

    SaveEvent({handleSubmit});

    return (
        <form onSubmit={handleSubmit}>
            <FormFields {...props}>
                <Divider className={classes.divider}/>
            </FormFields>
        </form>
    );
};

const FormConfig = withFormik({
    mapPropsToValues: props => mergeWithDefault(props.values, {
        id: '',
        number:'',
        first_name:'',
        last_name:'',
        birth_name:'',
        birth_date:'',
        entry_date:'',
        exit_date:'',
        iban:'',
        bic:'',
        remuneration_amount:'',
        allowance:'',
        meal_allowance_1:'',
        meal_allowance_2:'',
        total_reimbursement:'',
        amount_per_km:'',
        distance:'',
        type_of_remuneration:'salary',
        working_time_summer:null,
        working_time_winter:null,
        break:'',
        profession_id:'',
        editor_id: window.__DATA__._user.id,
        user_id:'',

    }),
    validationSchema: () => {
        let rules = {
            number: string().label(yupLabel('number')).required(),
            first_name: string().label(yupLabel('first_name')).required().min(2),
            last_name: string().label(yupLabel('last_name')).required().min(2),
            profession_id: string().label(yupLabel('profession')).required(),

        };
        return object().shape(rules);
    },
    validate: (values) => {
        const errors = {};
        if(values.iban){
            let iban = electronicFormatIBAN(values.iban)
            values.iban = iban;
            if( !isValidIBAN( iban ) ){
                errors.iban = i18n.get('personnel.validation.no_valid_iban');
            }
        }
        if(values.bic){
            values.bic = values.bic.toUpperCase();
            if( !isValidBIC( values.bic ) ){
                errors.bic = i18n.get('personnel.validation.no_valid_bic');
            }
        }
        return errors;
    },
    handleSubmit: (values, {setSubmitting}) => {
        setSubmitting(true);

        swal({
            title: i18n.get('personnel.dialog.save_title',{firstName: values.first_name, lastName: values.last_name} ),
            text: i18n.get('personnel.dialog.will_be_saved'),
            icon: 'info',
            buttons: {
                cancel: i18n.get('personnel.dialog.cancel'),
                confirm: {
                    text:i18n.get('personnel.dialog.save'),
                    closeModal: false,
                },
            },
            closeOnClickOutside: false,
            closeOnEsc: false,
        }).then(confirmed => {
            if(confirmed) {
                savePersonnel(values).then(data => {
                    if(data) {
                        return swal({
                            text: i18n.get('personnel.dialog.data_saved'),
                            icon: 'success',
                            timer: 4000,
                        }).then(() => {
                            setSubmitting(false);
                            if (data.id > 0) {
                                window.location.href = `/personnel`;
                            }
                        });
                    }
                });
            } else {
                setSubmitting(false);
            }
        });

    },
    validateOnBlur: true,
})(PersonnelForm);

const styles = theme => ({
    vSpace: {
        marginBottom: theme.spacing.unit * 1.5,
    },
    divider: {
        marginTop: theme.spacing.unit * 2,
        marginBottom:theme.spacing.unit * 2,
    },
    green: {
        color: green[600],
    },
    blue: {
        color: blue[600],
    },

    dividerHide: {
        [theme.breakpoints.up('xs')]: {
            display:'none',
        },
        [theme.breakpoints.down('xs')]: {
            display:'block',
        },
    }
});

export default withStyles(styles)(FormConfig);
